/**
 * 上のバーの Player / Creator の切り替えと、前のログイン用パスキーの案内（2026-10-07 console/one-account・設計 §2・§3）。
 * どちらも旗 oneAccount が on のときだけ出す（off なら何も描かない = 今の上のバーのまま）。
 */
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useT } from '../i18n';
import { accountPageUrl, modeHome, OLD_PASSKEY_KEY, PLAYER_PATH, saveMode, type ConsoleMode } from '../oneAccount';
import { useSession } from '../session';

const local = (): Storage | null => {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

export function ModeSwitch() {
  const { t } = useT();
  const { oneAccount, developer } = useSession();
  const location = useLocation();
  const navigate = useNavigate();
  if (!oneAccount.enabled) return null;
  // 今どちらを見ているかは URL で決める（Player の画面だけが PLAYER_PATH。ほかは全部 Creator の中身）
  const current: ConsoleMode = location.pathname === PLAYER_PATH ? 'player' : 'creator';
  const pick = (mode: ConsoleMode) => {
    // 最後に選んだ方を覚える（端末ごと・保存できなくても切り替えはできる = oneAccount.ts の saveMode）
    saveMode(local(), mode);
    if (mode !== current) navigate(modeHome(mode, developer !== null));
  };
  return (
    <div className="mode-switch" role="group" aria-label={t('oneAccount.mode.label')}>
      {(['player', 'creator'] as const).map((m) => (
        <button key={m} type="button" className={`mode-switch-btn ${current === m ? 'is-active' : ''}`} aria-pressed={current === m} onClick={() => pick(m)}>
          {t(m === 'player' ? 'oneAccount.mode.player' : 'oneAccount.mode.creator')}
        </button>
      ))}
    </div>
  );
}

/** 今のログイン用パスキーで入った作り手に「アカウントのページで 1 回登録し直して」（このタブで 1 回だけ・「あとで」で閉じる） */
export function OldPasskeyNotice() {
  const { t } = useT();
  const { oneAccount } = useSession();
  const [show, setShow] = useState(() => {
    try {
      return sessionStorage.getItem(OLD_PASSKEY_KEY) === '1';
    } catch {
      return false;
    }
  });
  if (!show || !oneAccount.accountUrl) return null;
  const close = () => {
    try {
      sessionStorage.removeItem(OLD_PASSKEY_KEY);
    } catch {
      /* 閉じるだけ */
    }
    setShow(false);
  };
  return (
    <div className="verify-banner" role="status">
      <span>
        <strong>{t('oneAccount.oldPasskey.title')}</strong> {t('oneAccount.oldPasskey.body')}
      </span>
      <a className="btn btn-sm" href={accountPageUrl(oneAccount.accountUrl)} target="_blank" rel="noopener noreferrer" onClick={close}>
        {t('oneAccount.oldPasskey.open')}
      </a>
      <button type="button" className="btn btn-ghost btn-sm" onClick={close}>
        {t('oneAccount.oldPasskey.later')}
      </button>
    </div>
  );
}
